var BASE_FONT_SIZE = 16;
export var pxToRem = function pxToRem(px) {
  return "".concat(px / BASE_FONT_SIZE, "rem");
};